var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_message-question",
    "data-name": "vuesax/bulk/message-question",
    transform: "translate(-2 -1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8615",
    "data-name": "Rectangle 8615",
    width: 20,
    height: 20,
    rx: 10,
    transform: "translate(2 1)",
    fill: "rgba(25,25,25,0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H19.534V18.534H0Z",
    transform: "translate(2.233 2.233)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M3.355,8A1.03,1.03,0,0,1,2.311,7v-.28a3.1,3.1,0,0,1,1.629-2.6c.515-.334.682-.56.682-.907A1.246,1.246,0,0,0,3.355,2,1.246,1.246,0,0,0,2.088,3.215a1.03,1.03,0,0,1-1.044,1A1.03,1.03,0,0,1,0,3.215,3.289,3.289,0,0,1,3.355,0,3.289,3.289,0,0,1,6.709,3.215a3.055,3.055,0,0,1-1.6,2.561c-.543.347-.71.574-.71.947V7A1.022,1.022,0,0,1,3.355,8Z",
    transform: "translate(8.645 5.837)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M1.044,2A1.021,1.021,0,0,1,0,1,1.03,1.03,0,0,1,1.044,0,1.03,1.03,0,0,1,2.088,1,1.021,1.021,0,0,1,1.044,2Z",
    transform: "translate(10.956 15.162)",
    fill: "#191919"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQmark);
export default __webpack_public_path__ + "static/media/qmark.f12cf92778ae8a485122d9b369b5751e.svg";
export { ForwardRef as ReactComponent };